export default "__VITE_ASSET__cdd0007f__"